import React from 'react';
import { useLocale } from '../../../contexts/LocaleContext.jsx';
import { editionAvailability } from '../../../_helpers/skinTryOn.js';
import '../../../styles/SkinAvailability.css';

/**
 * How many of a skin or FX item are left (ENG-833), the same on the shop
 * tile, the try-on, the FX try-on and the shelf's locked items. `offer` is a
 * normalized offer or shop item (skinTryOn.js / skinShop.js); the counting is
 * editionAvailability's.
 *
 * - Sold out: the one Sold out badge (`skin-sold-out`, `.skin-sold-out-badge`).
 * - Limited with a few left: "12 left · #489 of 500"; with many: "#201 of 500".
 * - Unlimited: "Unlimited" in the shop (`shop`), nothing elsewhere.
 * - Owned: no count. The shop says "Run of 500" next to its Owned badge;
 *   elsewhere nothing.
 */
const SkinAvailability = ({ offer, owned = false, shop = false }) => {
  const { t, format } = useLocale();
  const availability = editionAvailability(offer);
  if (!availability) return null;
  const { limited, size, left, nextEdition, soldOut, showLeft } = availability;

  if (soldOut && !owned) {
    return <span className="skin-sold-out-badge" data-testid="skin-sold-out">{t('shop.soldOut')}</span>;
  }

  let text = null;
  if (!limited) {
    text = shop ? t('shop.edition.unlimited') : null;
  } else if (owned || !nextEdition) {
    text = shop ? t('shop.edition.run', { size: format.number(size) }) : null;
  } else if (showLeft) {
    text = t('shop.edition.left', {
      count: left,
      number: format.number(left),
      next: format.number(nextEdition),
      size: format.number(size),
    });
  } else {
    text = t('shop.edition.next', { number: format.number(nextEdition), size: format.number(size) });
  }
  if (!text) return null;

  return (
    <span className={`skin-availability${showLeft && !owned ? ' skin-availability--low' : ''}`} data-testid="skin-availability">
      {text}
    </span>
  );
};

export default SkinAvailability;
